<template>
  <v-menu>
    <template #activator="{ props }">
      <v-btn v-bind="props" icon="mdi-download" variant="text" />
    </template>

    <v-list>
      <!-- Excel -->
      <v-list-item
        @click="exportFile('xlsx')"
        :loading="downloading === 'xlsx'"
      >
        <template #prepend>
          <v-icon color="success">mdi-file-excel</v-icon>
        </template>
        <v-list-item-title>Export Excel</v-list-item-title>
      </v-list-item>

      <!-- PDF -->
      <v-list-item
        @click="exportFile('pdf')"
        :loading="downloading === 'pdf'"
      >
        <template #prepend>
          <v-icon color="error">mdi-file-pdf-box</v-icon>
        </template>
        <v-list-item-title>Export PDF</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
import { ref } from 'vue'
import api from '@/services/api'
import download from 'downloadjs'

const props = defineProps({
  entity:   { type: String,  required: true },
  filename: { type: String,  default: ''   },
  /** array of {title,key} objects coming from the caller */
  headers:  { type: Array,   default: () => [] }
})

const downloading = ref(null)

async function exportFile (fmt) {
  downloading.value = fmt
  try {
    /* Build the ordered list of headers to send, skipping any UI-only columns */
    const exportHeaders = props.headers.filter(h => h.key !== 'actions')

    /* Call the endpoint � axios will URL-encode the params for us */
    const { data: blob, headers: respHdrs } = await api.get(
      `/${props.entity}/export`,
      {
        params: {              // query-string
          fmt,
          headers: JSON.stringify(exportHeaders)
        },
        responseType: 'blob'   // we expect a file back
      }
    )

    /* Pick filename from server hint, or fall back */
    const suggested =
      respHdrs['x-suggested-filename'] ||
      `${props.filename || props.entity}.${fmt}`

    /* Trigger download */
    download(
      blob,
      suggested,
      fmt === 'pdf'
        ? 'application/pdf'
        : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    )
  } finally {
    downloading.value = null
  }
}
</script>
